import { render, staticRenderFns } from "./testingPie.vue?vue&type=template&id=b7e8d1a2&scoped=true&"
import script from "./testingPie.vue?vue&type=script&lang=js&"
export * from "./testingPie.vue?vue&type=script&lang=js&"
import style0 from "./testingPie.vue?vue&type=style&index=0&id=b7e8d1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e8d1a2",
  null
  
)

export default component.exports